<template>
  <div id="login">
    <div class="row vh-100">
      <div class="col-12 col-lg-6 d-flex align-items-center">
        <div class="container">
          <div class="row">
            <div class="col-12 col-lg-8 offset-lg-2">
              <h3 class="text-bold text-center mb-3">Login</h3>
              <form action="" class="rounded shadow shadow-xs-none p-4" v-on:submit.prevent="loginUser">
                <div class="container">

                  <div class="mb-4 d-flex justify-content-center">
                    <router-link to="/" class="text-center">
                    <img width="50%" src="./../assets/images/home/PayMe4Cargo-01.png" alt="">
                    </router-link>
                  </div>

                  <h5 class="text-bold mb-4">Login</h5>
                  <b-alert show v-if="errorMessage" variant="danger">
                    {{errorMessage}}
                  </b-alert>
                  
                  <div class="login-view" v-if="!hasTwoFactorAuth">
                    <div class="form-group mb-4">
                      <div class="form-group" :class="{ 'hasError': $v.userData.email.$error }">
                          <p class="mb-1 font-weight-bold">Email</p>
                          <input type="text" v-model="userData.email" class="form-control" placeholder="Email Address" name="username">
                          <div class="error" v-if="(!$v.userData.email.required || !$v.userData.email.email) && $v.userData.email.$dirty">Email is required or Invalid Format</div>
                      </div>
                    </div>

                    <div class="form-group mb-2">
                      <div class="form-group" :class="{ 'hasError': $v.userData.password.$error }">
                          <p class="mb-1 font-weight-bold">Password</p>
                          <input type="password" v-model="userData.password" class="form-control" placeholder="Password" name="password">
                          <div class="error" v-if="!$v.userData.password.required && $v.userData.password.$dirty">Password is required</div>
                      </div>
                    </div>

                    <div class="mb-4">
                      <a href="#" @click.prevent="forgotPass"><small>Forgot Password?</small></a>
                    </div>

                    <div class="form-group mb-4 px-4">
                      <b-button :disabled="isLoading" class="btn btn-success w-100" type="submit" value="login" @click.prevent="loginUser">
                        <span v-if="!isLoading">Login</span>
                        <b-spinner v-else small label="Spinning" class="ml-2"></b-spinner>
                      </b-button>
                    </div>

                    <div>
                      <p class="mb-0 text-center text-bold">Don't have an account? <span><a href="#" @click.prevent="register()">Register Now</a></span></p>
                    </div>
                  </div>

                  <div class="twofactor-view" v-if="hasTwoFactorAuth">
                    <div class="form-group mb-4">
                      <div class="form-group" :class="{ 'hasError': $v.userData.email.$error }">
                          <p class="mb-1 font-weight-bold">Enter Auth Code</p>
                          <input type="text" v-model="authcode" class="form-control" placeholder="Enter Code" name="authcode">
                          <!-- <div class="error" v-if="(!$v.userData.email.required || !$v.userData.email.email) && $v.userData.email.$dirty">Email is required or Invalid Format</div> -->
                      </div>
                    </div>

                    <div class="form-group mb-4 px-4">
                      <b-button :disabled="isLoading" class="btn btn-success w-100" type="submit" value="login" @click.prevent="handleTwoFactor">
                        <span v-if="!isLoading">Login</span>
                        <b-spinner v-else small label="Spinning" class="ml-2"></b-spinner>
                      </b-button>
                    </div>

                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 d-none d-lg-flex login-right align-items-center">
        <ul class="h-100 d-flex flex-column justify-content-center px-5">
          <li class="text-white mb-3"><h5>Easy and simple payments in any currency for logistics vendors.</h5></li>
          <li class="text-white mt-3"><h5>Never get stuck making a payment at the bank, Get your client’s cargo released instantly.</h5></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .login-right {
    background-image: url("./../assets/images/signin/login-background.jpg");
    background-repeat: no-repeat;
    background-size: cover;
  }
  .login-right h5 {
    color: white;
    font-weight: bold;
  }
  @media (max-width: 575px) {
    .shadow-xs-none {
      box-shadow: none !important;
    }
  }
  @media (max-width: 991px) {
    
  }
  .form-control {
  background-color: #f7f7f7;
  border: 1px solid rgb(199, 199, 199);
  padding: 0.3rem 0.5rem;
  border-radius: 2px;

  .hasError & {
    border-color: red;
  }
}
.hasError p {
  color: red;
}
</style>
<script>
import { APPLICATION_KEY, jetPayNowApi } from '../api/jetpaynow_api';
import store from '../store';
import { required, email } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      isLoading: false,
      baseUrl: '',
      accountTypeMsg: 'Please Login',
      active: true,
      authenticated: '',
      validEmail: false,
      proceed: true,
      validateUser: {
        email_error: { 'form-error': false },
        password_error: { 'form-error': false },
        verificationPin_error: { 'form-error': false },
        activationPin_error: { 'form-error': false },
      },
      headerTag: {
        'animated fadeInUp': false,
        hidden: true,
      },
      userData: {
        email: '',
        password: '',
        verificationPin: '',
        activationPin: '',
        ip_address: '',
        country_code: '',
        device_type: 'WEB',
      },
      tempUser: {},
      tempToken: '',
      loginVerification: 0,
      errorMessage: '',
      loadingMessage: '',
      authMessage: '',
      authUser: {},
      authcode: '',
      hasTwoFactorAuth: false,
      twoFactorAuthPayload: {}
    };
  },
  validations: {
    userData: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  },
  props: ['session', 'paymentMode'],
  mounted() {
    // Dynamic Port Mapping for Auth Service
    this.baseUrl = `${process.env.VUE_APP_AUTH_URL}`;

    setTimeout(() => {
      this.headerTag = {
        'animated fadeInUp': true,
        hidden: false,
      };
      setTimeout(() => {
        this.headerTag = {
          'animated fadeInDown': false,
          hidden: false,
        };
      }, 1500);
    }, 100);
  },
  beforeMount() {
    this.tokenizer();
  },
  methods: {
    tokenizer() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (userContext) {
        window.location.href = './dashboard';
      }
    },
    loginUser() {
      this.$v.userData.$touch();

      if (!this.$v.userData.$error) {
        this.proceed = true;
        const formActor = this.proceed;
        this.processRequest(formActor);
        this.isLoading = true;
      }
    },
    processRequest(formActor) {
      this.errorMessage = "";
      const $this = this;

      if (formActor) {
        this.loadingMessage = 'Verifying Your Credentials';

        this.authUser = btoa(`${this.userData.email.toLowerCase()}:${this.userData.password}`);
        const authHeader = {
          headers: {
            Authorization: `${this.authUser}`,
            'Content-Type': 'application/json',
          },
        };

        const data = {
          email: this.userData.email,
          password: this.userData.password
        };

        // quick login for demo purposes
        if (data.email == 'demo@user.com' && data.password == 'letmein') {
          this.handleLocalStorage({
            data: {
              "id": 123,
              "2fa": false,
              "user_id": "demo_user",
              "access": "2763664c532bac9b11ff59e9caf2103e",
              "user": {
                "account": {
                  "is_vendor": true
                }
              }
            }
          });
        } else {
          this.errorMessage = "Invalid username / password";
        }
        // jetPayNowApi
        //   .get(`${this.baseUrl}/login/`, data, authHeader)
        //   .then(loginResponse => {
        //     if (loginResponse.status === 200 && loginResponse.statusText === 'OK') {
        //       // console.log('loginResponse', loginResponse);
        //       this.hasTwoFactorAuth = loginResponse.data['2fa'];
        //       const user_id = loginResponse.data['user_id'];

        //       if (this.hasTwoFactorAuth) {
        //         this.twoFactorAuthPayload = {
        //           user_id: user_id,
        //           code: null
        //         };
        //       } else {
        //         this.handleLocalStorage(loginResponse)
        //       }
        //     }
        //   })
        //   .catch(error => {
        //     const temp = String(error);
        //     if (temp.includes('Network Error')) {
        //       this.errorMessage = temp.split(':')[1];
        //     }
        //     if (temp.includes('401')) {
        //       this.errorMessage = "Invalid username / password";
        //     }
        //   })
        //   .finally(() => {
        //     this.isLoading = false;
        //   });
      }
    },
    register() {
      this.$router.push('/register', () => {});
    },
    forgotPass() {
      this.$router.push('/forgot-password', () => {});
    },
    handleLocalStorage(loginResponse) {
      const loginToken = {
        token: loginResponse.data.access,
        ...loginResponse.data,
      };

      loginToken['user_digest'] = loginResponse.data.user;
      loginToken['user_digest'].role_name = loginResponse.data.user.account.is_vendor ? 'JetPayNow Vendor' : 'JetPayNow Payer';
      loginToken['user_digest'].role_code = loginResponse.data.user.account.is_vendor ? 'JPNV' : 'JPNP';
      loginToken['user_digest'].views = [];

      localStorage.setItem('loginToken', JSON.stringify(loginToken));

      // if (mixpanel) {
      //   mixpanel.track("User Log In", {"user type": "vendor/payer"});
      // }
      
      const hasReturnUrl = this.$route.query.ReturnURL;

      if (hasReturnUrl) {
        window.location.href = hasReturnUrl + '/?session_id=' + loginResponse.data.session_id;
      } else {
        window.location.href = './';
      }
      
    },
    handleTwoFactor(evt) {
      this.errorMessage = '';
      this.twoFactorAuthPayload.code = this.authcode;

      jetPayNowApi
        .post(`${this.baseUrl}/accounts/validate_otp/`, this.twoFactorAuthPayload)
        .then(loginResponse => {
          if (loginResponse.status === 200 && loginResponse.statusText === 'OK') {
            console.log('loginResponse.data', JSON.stringify(loginResponse.data));
            this.handleLocalStorage(loginResponse);
          }
        })
        .catch(error => {
          console.log('error', error);
          this.errorMessage = 'Error: Auth Code Incorrect.';
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
};
</script>